import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { BranchApiService } from './branch-api-service';

export class BranchDataSource extends ApiDataSource {
  protected Data: BehaviorSubject<[]> = new BehaviorSubject([]);
  constructor(protected Api: BranchApiService, private readonly role: any) {
    super();
  }

  protected loadData(): Promise<void | IResponseBody> {
    return this.Api.get();
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data.branch);
  }
}
